import { useAppContext } from '@/App.context'

import './loader-circle.scss'

const LoaderCircle = () => {
  const { whiteLabel } = useAppContext()

  return <div className={`loader loader-circle wl-${whiteLabel}`} />
}

export default LoaderCircle
